<template>
  <div
    v-if="selectedPlan !== null && selectedPlan !== undefined"
    ref="container"
  >
    <v-container>
      <v-row justify="center">
        <v-dialog scrollable v-model="loading" persistent max-width="200">
          <v-card>
            <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout row justify-center>
                  <v-flex xs12 sm6 md4 lg3>
                    <v-progress-circular indeterminate></v-progress-circular>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-dialog v-model="warningDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">
              {{ $t("views.planwizardview.warning_exit_without_save") }}
            </v-card-title>
            <v-card-text>
              {{ $t("views.planwizardview.warning_exit_without_save_confirm") }}
            </v-card-text>
            <v-card-actions>
              <v-btn
                color
                text
                @click="
                  warningDialog = false;
                  warningResult = false;
                "
              >
                {{ $t("globals.cancel") }}
              </v-btn>
              <v-btn
                color="primary"
                @click="
                  warningDialog = false;
                  warningResult = true;
                "
              >
                {{ $t("views.planwizardview.remove_draft") }}
              </v-btn>
              <v-btn color="primary" @click="warningDialogSave">
                {{ $t("globals.save") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
    <template
      v-if="
        dataContainer !== null &&
        dataContainer !== undefined &&
        payload !== null &&
        payload !== undefined
      "
    >
      <div
        v-show="isFixedActionsBarVisible"
        :style="{
          position: 'fixed',
          top: '0',
          background: 'white',
          width: actionBarWidth,
          'overflow-x': 'auto',
          'z-index': 2,
          'padding-right': '50px',
        }"
      >
        <v-card-actions>
          <v-btn
            :disabled="!isValid || !isChanged"
            color="primary"
            text
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
          <!-- <v-spacer/> -->
          <v-btn color="success" text @click="importHandler">
            {{ $t("globals.import") }}
          </v-btn>
          <v-btn
            :disabled="isChanged"
            color="warning"
            text
            @click="exportHandler"
          >
            {{ $t("globals.export") }}
          </v-btn>
          <v-spacer />
          <v-btn :disabled="allExpanded" text @click="all">
            {{ $t("globals.expand_all") }}
          </v-btn>
          <v-btn :disabled="allCollapsed" text @click="none">
            {{ $t("globals.collapse_all") }}
          </v-btn>
          <!-- <v-spacer /> -->
        </v-card-actions>
      </div>
      <v-dialog scrollable v-model="importDialog" persistent max-width="400">
        <material-card
          :title="
            $t('components.portal.portal_configuration.import_configuration')
          "
          icon="toggle_on"
          :color="$vuetify.theme.themes.light.success"
        >
          <v-card-text>
            <v-container fluid grid-list-md>
              <v-layout row justify-center>
                <v-flex sm12>
                  <v-file-input
                    :label="
                      $t(
                        'components.portal.portal_configuration.select_configuration_file'
                      )
                    "
                    v-on:change="handleFileChange"
                    accept=".json"
                    v-model="file"
                  ></v-file-input>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="
                importDialog = false;
                file = undefined;
              "
              :loading="importing"
            >
              {{ $t("globals.cancel") }}
            </v-btn>
            <v-btn
              color="primary"
              @click="importFile"
              :disabled="file === undefined"
              :loading="importing"
            >
              {{ $t("globals.import") }}
            </v-btn>
          </v-card-actions>
        </material-card>
      </v-dialog>
      <v-card id="main-card" elevation="0">
        <v-card-actions id="top-actions" v-show="!isFixedActionsBarVisible">
          <v-btn
            :disabled="!isValid || !isChanged"
            color="primary"
            text
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
          <v-btn color="success" text @click="importHandler">
            {{ $t("globals.import") }}
          </v-btn>
          <v-btn
            :disabled="isChanged"
            color="warning"
            text
            @click="exportHandler"
          >
            {{ $t("globals.export") }}
          </v-btn>
          <v-spacer />
          <v-btn :disabled="allExpanded" text @click="all">
            {{ $t("globals.expand_all") }}
          </v-btn>
          <v-btn :disabled="allCollapsed" text @click="none">
            {{ $t("globals.collapse_all") }}
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-expansion-panels v-model="panel" style="margin-top: 10px" multiple>
            <portal-settings
              ref="general"
              :dataContainer="dataContainer"
              @update="updateGeneralSettings"
              @update-plan-information="
                dataContainer.portal.planInformation = $event
              "
              @valid="valid.portalSettings = $event"
              :payload="payload"
              @domain="payload.Domain = $event"
              @legacy="payload.UseLegacyClaims = $event"
            />
            <theme-options
              ref="theme"
              :dataContainer="dataContainer"
              @update-theme-colors="updateTheme"
              @update-left-drawer="
                dataContainer.portal.theme.LeftDrawer.Light = $event;
                checkChanged();
              "
              @update-right-drawer="
                dataContainer.portal.theme.RightDrawer.Light = $event;
                checkChanged();
              "
              @update-app-bar="
                dataContainer.portal.theme.AppBar.Light = $event;
                checkChanged();
              "
              @update-app-footer="
                dataContainer.portal.theme.AppFooter.Light = $event;
                checkChanged();
              "
              @update-main-view="
                dataContainer.portal.theme.MainView.Light = $event;
                checkChanged();
              "
              @valid="valid.themeOptions = $event"
            />
            <content-management
              ref="content"
              :dataContainer="dataContainer"
              @update="updateContent"
              @update-download-centre="
                dataContainer.portal.downloadCentreData = $event;
                checkChanged();
              "
              @update-download-centre-categories="
                updateDownloadCentreCategories
              "
              @update-faq="
                dataContainer.portal.faq = $event;
                checkChanged();
              "
              @update-faq-groups="updateFaqGroups"
              @update-mle="updateLifeEvents"
              @update-mle-groups="updateMleGroups"
              @update-mle-categories="updateMleCategories"
              @update-pp="updateProvs"
              @update-pp-categories="updatePpCategories"
              @update-plan-notifications-table="
                dataContainer.portal.planNotifications = $event;
                checkChanged();
              "
              @valid="valid.contentManagement = $event"
              :selectedLanguages="dataContainer.portal.languages"
              :systemColors="systemColors"
              :downloadCentreCategories="
                dataContainer.portal.downloadCentreCategories
              "
              :downloadCentreData="dataContainer.portal.downloadCentreData"
              :faqGroups="dataContainer.portal.faqGroups"
              :faq="dataContainer.portal.faq"
              :mleGroups="dataContainer.portal.mleGroups"
              :mle="dataContainer.portal.lifeEventsCCWIPP.Members"
              :mleCategories="dataContainer.portal.mleCategories"
              :providers="dataContainer.portal.providers"
              :ppCategories="dataContainer.portal.ppCategories"
              :hasPreferredProviders="
                dataContainer.portal.hasPreferredProviders
              "
            />
            <student-wellness
              v-if="selectedPlan.PlanType === 'HW'"
              :portal="dataContainer.portal"
              @update="updateStudentWellness"
              @valid="valid.studentWellness = $event"
            />
            <contact-form-settings
              ref="contact"
              :dataContainer="dataContainer"
              @update="updateContact"
              @update-admin-email-recipients="
                dataContainer.portal.adminEmailRecipients = $event;
                checkChanged();
              "
              @update-contact-request-types="
                dataContainer.portal.contactRequestType = $event;
                checkChanged();
              "
              @update-contact-subject-types="
                dataContainer.portal.contactSubjectType = $event;
                checkChanged();
              "
              @valid="valid.contactFormSettings = $event"
              :selectedLanguages="dataContainer.portal.languages"
            />
            <dashboard-items-table
              :items="dataContainer.portal.dashboardItems"
              @update="
                dataContainer.portal.dashboardItem = $event;
                checkChanged();
              "
            />
            <left-drawer-only-opt-outs-menu-items-table
              :items="dataContainer.portal.leftDrawerJustOptOutItems"
              @update="
                dataContainer.portal.leftDrawerJustOptOutItems = $event;
                checkChanged();
              "
              :systemColors="systemColors"
              :selectedLanguages="dataContainer.portal.languages"
            />
            <left-drawer-menu-items-table
              :items="dataContainer.portal.leftDrawerMenuItems"
              @update="
                dataContainer.portal.leftDrawerMenuItems = $event;
                checkChanged();
              "
              :systemColors="systemColors"
              :selectedLanguages="dataContainer.portal.languages"
            />
            <footer-items-card
              :dataContainer="dataContainer"
              @update="updateFooter"
              @valid="valid.footerItems = $event"
            />
            <logout-urls-table
              :items="dataContainer.portal.logoutUrls"
              @update="
                dataContainer.portal.logoutUrls = $event;
                checkChanged();
              "
            />
            <demo-settings
              v-if="dataContainer.portal.isDemoMockPlan"
              ref="demo"
              :dataContainer="dataContainer"
              @update="updateDemo"
              @update-demo-plans="
                dataContainer.portal.demoPlansList = $event;
                checkChanged();
              "
              @update-demo-benefit-cards="
                dataContainer.portal.demoBenefitCards = $event;
                checkChanged();
              "
              :selectedLanguages="dataContainer.portal.languages"
            />
            <advanced-settings
              ref="advanced"
              :dataContainer="dataContainer"
              @update="updateAdvanced"
              @update-dashboard-item-types="
                dataContainer.portal.dashboardItemTypes = $event;
                checkChanged();
              "
              @update-pension-information-items="
                dataContainer.portal.pensionInformationItems = $event;
                checkChanged();
              "
              @update-member-information-items="
                dataContainer.portal.memberInformationItems = $event;
                checkChanged();
              "
              @update-horizontal-menu-items="
                dataContainer.portal.horizontalMenuItems = $event;
                checkChanged();
              "
              @valid="valid.advancedSettings = $event"
              :selectedLanguages="dataContainer.portal.languages"
            />
          </v-expansion-panels>
          <!-- <v-form v-model="valid.form">
            <v-row>
              <v-col xs="12" sm="6" md="4" lg="3">
                <no-autocomplete-textfield
                  v-model="payload.Domain"
                  :label="$t('components.portal.portal_content.domain')"
                  :rules="[$rules.required]"
                  class="required"
                />
              </v-col>
              <v-col
                xs="12"
                sm="6"
                md="4"
                lg="3"
                v-if="payload.UseLegacyClaims"
              >
                <v-checkbox
                  readonly
                  v-model="payload.UseLegacyClaims"
                  :label="$t('components.portal.portal_content.use_legacy')"
                />
              </v-col>
            </v-row>
          </v-form> -->
        </v-card-text>
        <v-card-actions id="bottom-actions">
          <v-btn
            :disabled="!isValid || !isChanged"
            color="primary"
            text
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
          <v-btn color="success" text @click="importHandler">
            {{ $t("globals.import") }}
          </v-btn>
          <v-btn
            :disabled="isChanged"
            color="warning"
            text
            @click="exportHandler"
          >
            {{ $t("globals.export") }}
          </v-btn>
          <v-spacer />
          <v-btn :disabled="allExpanded" text @click="all">
            {{ $t("globals.expand_all") }}
          </v-btn>
          <v-btn :disabled="allCollapsed" text @click="none">
            {{ $t("globals.collapse_all") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
    <error-handler :error="error" />
    <v-snackbar
      v-model="snackbar"
      color="success"
      :multi-line="false"
      :timeout="timeout"
      :vertical="false"
    >
      {{ $t("globals.success") }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="purple"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ErrorHandler from "../ErrorHandler.vue";
import { locker } from "@/mixins/locker";
import { planSetter } from "@/mixins/planSetter";
// import PlanSettingsCard from "./PlanSettingsCard.vue";
import LeftDrawerMenuItemsTable from "./LeftDrawerMenuItemsTable.vue";
import LeftDrawerOnlyOptOutsMenuItemsTable from "./LeftDrawerOnlyOptOutsMenuItemsTable.vue";
import DashboardItemsTable from "./DashboardItemsTable.vue";
import PortalSettings from "./PortalSettings.vue";
import FooterItemsCard from "./FooterItemsCard.vue";
import StudentWellness from "./StudentWellness.vue";
import LogoutUrlsTable from "./LogoutUrlsTable.vue";
import ThemeOptions from "./ThemeOptions.vue";
import ContentManagement from "./ContentManagement.vue";
import ContactFormSettings from "./ContactFormSettings.vue";
import AdvancedSettings from "./AdvancedSettings.vue";
import DemoSettings from "./DemoSettings.vue";

export default {
  components: {
    ErrorHandler,
    // PlanSettingsCard,
    PortalSettings,
    LeftDrawerMenuItemsTable,
    LeftDrawerOnlyOptOutsMenuItemsTable,
    DashboardItemsTable,
    FooterItemsCard,
    StudentWellness,
    LogoutUrlsTable,
    ThemeOptions,
    ContentManagement,
    ContactFormSettings,
    AdvancedSettings,
    DemoSettings,
  },
  data() {
    return {
      dataContainer: undefined,
      payload: undefined,
      loading: false,
      snackbar: false,
      timeout: 2500,
      saving: false,
      error: null,
      // memberTypes: ["All"],
      valid: {
        // planSettings: false,
        portalSettings: false,
        themeOptions: false,
        contentManagement: false,
        footerItems: false,
        studentWellness: false,
        contactFormSettings: false,
        advancedSettings: false,
        // form: false,
      },
      isValid: false,
      isFixedActionsBarVisible: false,
      timeoutResult: null,
      importDialog: false,
      warningDialog: false,
      warningResult: false,
      file: undefined,
      importing: false,
      panel: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      items: 11,
      // memberGroups: [
      //   "Maple Leaf Winnipeg",
      //   "Maple Leaf Paquin - Road",
      //   "Maple Leaf Brandon",
      //   "Maple Leaf London",
      //   "Maple Leaf Heritage",
      // ],
      systemColors: [],
      originalData: null,
      routeData: null,
      isChanged: false,
    };
  },
  mixins: [locker, planSetter],
  computed: {
    ...mapGetters("common", ["language", "languages"]),
    ...mapGetters("auth", ["role", "user"]),
    ...mapGetters("common", {
      selectedPlan: "plan",
      settings: "settings",
      brokerId: "brokerId",
    }),
    ...mapGetters("plansMembers", ["planIdentity", "planOptions"]),
    ...mapGetters("navbar", ["drawer"]),
    allExpanded() {
      return (
        JSON.stringify(this.panel) ===
        JSON.stringify([...Array(this.items).keys()].map((k, i) => i))
      );
    },
    allCollapsed() {
      return JSON.stringify(this.panel) === JSON.stringify([]);
    },
    actionBarWidth() {
      if (this.drawer) {
        return `${window.innerWidth - 260}px`;
      }
      return "100%";
    },
  },
  watch: {
    warningResult: {
      async handler(v) {
        if (v) {
          this.routeData.next();
        } else {
          if (this.routeData && this.routeData.next) {
            this.routeData.next(false);
          }
        }
      },
    },
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
    valid: {
      handler() {
        console.log("valid--------------------------------------");
        this.$nextTick(() => {
          this.isValid = this.isValidFunc();
        });
      },
      deep: true,
    },
  },
  async mounted() {
    // this.panel = [...Array(this.items).keys()].map((k, i) => i);
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      await this.loadPlanData();
    }
    // this.loading = true;
    // window.addEventListener("resize", this.onWindowSizeChanged);
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    ...mapActions("portalsProxy", [
      "getPlanPortalConfiguration",
      "savePlanPortalConfiguration",
    ]),
    ...mapActions("plansMembers", ["savePortalSettings"]),

    displayWarning(next) {
      this.warningResult = null;
      if (this.isChanged) {
        this.routeData = {
          next: next,
        };
        this.warningDialog = true;
      } else {
        next();
      }
    },
    all() {
      this.panel = [...Array(this.items).keys()].map((k, i) => i);
      this.$refs.advanced.all();
      this.$refs.demo && this.$refs.demo.all();
      this.$refs.contact.all();
      this.$refs.content.all();
      this.$refs.general.all();
      this.$refs.theme.all();
    },
    // Reset the panel
    none() {
      // console.log(
      //   "$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$"
      // );
      this.panel = [];
      if (this.$refs.advanced) {
        this.$refs.advanced.none();
      }
      if (this.$refs.demo) {
        this.$refs.demo.none();
      }
      if (this.$refs.contact) {
        this.$refs.contact.none();
      }
      if (this.$refs.content) {
        this.$refs.content.none();
      }
      if (this.$refs.general) {
        this.$refs.general.none();
      }
      if (this.$refs.theme) {
        this.$refs.theme.none();
      }
    },
    onWindowSizeChanged() {
      this.onScroll();
    },
    onScroll() {
      clearTimeout(this.timeoutResult);
      this.timeoutResult = setTimeout(() => {
        if (
          this.$refs.container === undefined ||
          this.$el.querySelector === undefined
        ) {
          return;
        }
        const materialCardElement = document.getElementById("main-card");
        if (materialCardElement === null || materialCardElement === undefined) {
          return;
        }
        const rect = materialCardElement.getBoundingClientRect();
        const bottomVisible = this.isElementInViewport(
          document.getElementById("bottom-actions")
        );
        const materialCardTopVisible = rect.top < 98 && !bottomVisible;
        if (!materialCardTopVisible) {
          this.isFixedActionsBarVisible = false;
          return;
        }
        this.isFixedActionsBarVisible = true;
      }, 100);
    },
    isElementInViewport(el) {
      var rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight ||
            document.documentElement
              .clientHeight) /* or $(window).height() */ &&
        rect.right <=
          (window.innerWidth ||
            document.documentElement.clientWidth) /* or $(window).width() */
      );
    },
    async handleFileChange(file) {
      if (!file) {
        this.file = undefined;
        return;
      }
      this.file = file;
    },
    importFile() {
      this.importing = true;
      let fr = new FileReader();
      fr.onload = () => {
        this.newPortalConfiguration(JSON.parse(fr.result));
        this.payload = {
          UseLegacyClaims: this.selectedPlan.UseISeriesClaims,
          Domain: this.payload.Domain,
        };
        this.importDialog = false;
        this.importing = false;
      };
      fr.onerror = (err) => {
        console.log(err);
        let error = new Error();
        error.customMessage = this.$t(
          "components.portal.portal_configuration.read_configuration_error"
        );
        this.error = error;
        this.importing = false;
      };
      fr.readAsText(this.file);
    },
    importHandler() {
      this.importDialog = true;
    },
    exportHandler() {
      this.download(
        JSON.stringify(this.dataContainer.portal),
        `${this.selectedPlan.Id}.json`,
        "text/plain"
      );
    },
    download(content, fileName, contentType) {
      var a = document.createElement("a");
      var file = new Blob([content], { type: contentType });
      a.href = URL.createObjectURL(file);
      a.download = fileName;
      a.click();
    },
    isValidFunc() {
      const keys = Object.keys(this.valid);
      for (let key of keys) {
        if (this.valid[key] === false) {
          console.log(
            "is valid:-----------------------------------------------------------------------------",
            key,
            this.valid
          );
          return false;
        }
      }
      return true;
    },
    newPortalConfiguration(p) {
      let portal;
      if (p === null || p === undefined) {
        portal = {
          theme: {
            Vuetify: {
              Light: {},
            },
            LeftDrawer: {
              Light: {
                Colors: {
                  MenuButton: {},
                },
              },
            },
            RightDrawer: {
              Light: {
                Colors: {
                  MenuButton: {},
                  MenuIcon: {},
                },
              },
            },
            AppBar: {
              Light: {
                Colors: {
                  SystemBar: {},
                  SearchField: {},
                },
              },
            },
            AppFooter: {
              Light: {
                Colors: {},
              },
            },
            MainView: {
              Light: {
                Colors: {},
              },
            },
          },
        };
      } else {
        portal = p;
      }
      portal.planIdentityId = this.selectedPlan.Id;
      // portal.isPensionsPortal = this.selectedPlan.PlanType === "Pension";
      portal.planNumber = this.planIdentity.UniqueIdentifier;
      // portal.hasBeneficiaries = this.planOptions.HasBeneficiaries;
      // portal.planAdministratorName = this.planIdentity.Current.Name;
      if (
        portal.lifeEventsCCWIPP === null ||
        portal.lifeEventsCCWIPP === undefined
      ) {
        portal.lifeEventsCCWIPP = {
          Members: [],
        };
      } else if (
        portal.lifeEventsCCWIPP.Members === null ||
        portal.lifeEventsCCWIPP.Members === undefined
      ) {
        portal.lifeEventsCCWIPP.Members = [];
      }

      if (portal.mleGroups === null || portal.mleGroups === undefined) {
        let groups = {};
        for (const item of portal.lifeEventsCCWIPP.Members) {
          if (groups[item.GroupEN] === undefined) {
            groups[item.GroupEN] = {
              GroupEN: item.GroupEN,
              GroupFR: item.GroupFR,
              GroupIcon: item.GroupIcon,
              GroupIconColor: item.GroupIconColor,
            };
          }
        }
        portal.mleGroups = Object.values(groups);
      }
      if (portal.mleCategories === null || portal.mleCategories === undefined) {
        let categories = {};
        for (const item of portal.lifeEventsCCWIPP.Members) {
          if (categories[item.CategoryEN] === undefined) {
            categories[item.CategoryEN] = {
              CategoryId: item.CategoryId,
              CategoryEN: item.CategoryEN,
              CategoryFR: item.CategoryFR,
              CategoryImage: item.CategoryImage,
              CategoryTextEN: item.CategoryTextEN,
              CategoryTextFR: item.CategoryTextFR,
            };
          }
        }
        portal.mleCategories = Object.values(categories);
      }

      portal.providers = [];
      portal.ppCategories = [];
      if (
        portal.preferredProviders !== null &&
        portal.preferredProviders !== undefined
      ) {
        if (Array.isArray(portal.preferredProviders)) {
          for (const item of portal.preferredProviders) {
            if (item.Providers !== null && item.Providers !== undefined) {
              const p = item.Providers.map((o) => {
                // console.log(o);
                o.CategoryId = item.CategoryId;
                for (const lang of this.languages) {
                  if (o.Info !== null && o.Info !== undefined) {
                    if (o.Info.length > 0) {
                      o[`Title${lang.language.toUpperCase()}`] =
                        o.Info[0][`Title${lang.language.toUpperCase()}`];
                      o[`Image${lang.language.toUpperCase()}`] =
                        o.Info[0][`Image${lang.language.toUpperCase()}`];
                      o[`Detail${lang.language.toUpperCase()}`] =
                        o.Info[0][`Detail${lang.language.toUpperCase()}`];
                    }
                    if (o.Info.length > 1) {
                      o[`DescriptionDetail${lang.language.toUpperCase()}`] =
                        o.Info[1][`Detail${lang.language.toUpperCase()}`];
                    }
                    if (o.Info.length > 2) {
                      o[
                        `ContactInformationDetail${lang.language.toUpperCase()}`
                      ] = o.Info[2][`Detail${lang.language.toUpperCase()}`];
                    }
                  }
                }
                return o;
              });

              portal.providers = portal.providers.concat(p);
              delete item.Providers;
            }
            portal.ppCategories.push(item);
          }
        } else {
          console.log(
            "ERROR in preferred providers: ",
            JSON.stringify(portal.preferredProviders)
          );
        }
      }

      if (portal.footerItems === null || portal.footerItems === undefined) {
        portal.footerItems = {};
      }
      if (
        portal.memberRegistrationComponent === null ||
        portal.memberRegistrationComponent === undefined
      ) {
        portal.memberRegistrationComponent = {};
      }
      if (
        portal.registrationCompletionComponent === null ||
        portal.registrationCompletionComponent === undefined
      ) {
        portal.registrationCompletionComponent = {};
      }
      if (
        portal.downloadCentreData !== null &&
        portal.downloadCentreData !== undefined
      ) {
        if (
          portal.downloadCentreCategories === null ||
          portal.downloadCentreCategories === undefined
        ) {
          let categories = {};
          for (const item of portal.downloadCentreData) {
            if (categories[item.CategoryEN] === undefined) {
              categories[item.CategoryEN] = {
                CategoryEN: item.CategoryEN,
                CategoryFR: item.CategoryFR,
                CategoryIcon: item.CategoryIcon,
                CategoryIconColor: item.CategoryIconColor,
                CategoryTabColor: item.CategoryTabColor,
              };
            }
          }
          portal.downloadCentreCategories = Object.values(categories);
        }
      }
      if (portal.faq !== null && portal.faq !== undefined) {
        if (portal.faqGroups === null || portal.faqGroups === undefined) {
          let groups = {};
          for (const item of portal.faq) {
            if (groups[item.GroupEN] === undefined) {
              groups[item.GroupEN] = {
                GroupEN: item.GroupEN,
                GroupFR: item.GroupFR,
                GroupIcon: item.GroupIcon,
                GroupIconColor: item.GroupIconColor,
                GroupTabColor: item.GroupTabColor,
              };
            }
          }
          portal.faqGroups = Object.values(groups);
        }
      }
      this.dataContainer = {
        portal: JSON.parse(JSON.stringify(portal)),
      };
      this.originalData = this.removeIdentifiers(
        JSON.parse(JSON.stringify(portal))
      );
    },
    async loadPlanData() {
      try {
        this.loading = true;
        let item;
        // if (this.lockId) {
        //   item = (
        //     await this.getPlanPortalConfiguration({
        //       planIdentityId: this.selectedPlan.Id,
        //     })
        //   ).data;
        // } else {
        item = (
          await this.lock(
            this.getPlanPortalConfiguration,
            {
              planIdentityId: this.selectedPlan.Id,
              warning: true,
            },
            null,
            true,
            false,
            true
          )
        ).data;
        // }

        if (item !== null && item !== undefined && item != "") {
          this.payload = item;
          this.newPortalConfiguration(item.Json);
        } else {
          this.payload = {};
        }
        this.payload.UseLegacyClaims = this.selectedPlan.UseISeriesClaims;

        this.isChanged = false;
      } catch (error) {
        console.log(error);
        if (error.response.status === 404) {
          this.newPortalConfiguration();
          this.payload = {};
        } else {
          this.error = error;
        }
      } finally {
        this.$nextTick(() => {
          this.none();
          this.loading = false;
        });
      }
    },
    async warningDialogSave() {
      await this.save();
      this.warningDialog = false;
      this.warningResult = true;
    },
    async save() {
      try {
        this.saving = true;
        this.payload.UseLegacyClaims = this.selectedPlan.UseISeriesClaims;

        if (typeof this.dataContainer.portal.allowedEmailDomains === "string") {
          this.dataContainer.portal.allowedEmailDomains = this.dataContainer.portal.allowedEmailDomains
            .split(",")
            .map(domain => domain.trim())
            .filter(domain => domain);
        }
        let portal = JSON.parse(JSON.stringify(this.dataContainer.portal));
        // Assuming portal.providers and portal.ppCategories are already populated
        portal.preferredProviders = [];

        const providersByCategory = portal.providers.reduce((acc, provider) => {
          if (!acc[provider.CategoryId]) {
            acc[provider.CategoryId] = [];
          }
          acc[provider.CategoryId].push(provider);
          return acc;
        }, {});

        for (const category of portal.ppCategories) {
          const providers = providersByCategory[category.CategoryId] || [];
          const item = {
            CategoryId: category.CategoryId,
            CategoryIcon: category.CategoryIcon,
            IconColor: category.IconColor,
            TextColor: category.TextColor,
            CategoryEN: category.CategoryEN,
            CategoryFR: category.CategoryFR,
            CategoryImage: category.CategoryImage,
            CategoryTextEN: category.CategoryTextEN,
            CategoryTextFR: category.CategoryTextFR,
            Providers: providers.map((provider) => {
              delete provider.Category;
              delete provider.DescriptionDetailEN;
              delete provider.DescriptionDetailFR;
              delete provider.ContactInformationDetailEN;
              delete provider.ContactInformationDetailFR;
              delete provider.TitleEN;
              delete provider.TitleFR;
              delete provider.ImageEN;
              delete provider.ImageFR;
              delete provider.DetailEN;
              delete provider.DetailFR;
              delete provider.CategoryId;
              const o = { ...provider };
              delete o.CategoryId;
              return o;
            }),
          };
          portal.preferredProviders.push(item);
        }

        console.log("save providers: ", portal.preferredProviders);

        const data = this.removeIdentifiers(JSON.parse(JSON.stringify(portal)));
        this.payload.Json = data;
        this.payload.UpdatedBy = this.user;
        this.payload.Source = "PortalUI";
        await this.savePlanPortalConfiguration({
          planIdentityId: this.selectedPlan.Id,
          payload: this.payload,
        });
        await this.savePortalSettings({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            OnlineEnrolment: this.dataContainer.portal.canEditDependants,
          },
        });
        this.snackbar = true;
        this.originalData = this.removeIdentifiers(
          JSON.parse(JSON.stringify(this.dataContainer.portal))
        );
        this.isChanged = !this.sameObject(
          this.originalData,
          this.removeIdentifiers(
            JSON.parse(JSON.stringify(this.dataContainer.portal))
          )
        );
      } catch (error) {
        this.error = error;
      } finally {
        console.log("this.dataContainer.portal: ", this.dataContainer.portal);
        this.saving = false;
      }
    },
    removeIdentifiers(source) {
      console.log(
        "-----------------------------------------------source is:",
        source
      );
      if (Array.isArray(source)) {
        let target = source.map((o) => {
          delete o.Identifier;
          return this.removeIdentifiers(o);
        });
        // if (target.length > 0) {
        return target; //.map(o=>o!==undefined);
        // }
        // return undefined;
      } else if (typeof source === "object" && source !== null) {
        let target = {};
        for (let key of Object.keys(source)) {
          if (source[key] !== null && source[key] !== undefined) {
            delete source[key].Identifier;
            target[key] = this.removeIdentifiers(source[key]);
          }
        }
        // for (let key of Object.keys(target)) {
        //   if (target[key] === undefined) {
        //     delete target[key];
        //   }
        // }
        if (Object.keys(target).length > 0) {
          return target;
        }
        return undefined;
      } else {
        if (source === "") {
          return undefined;
        }
        return source;
      }
    },
    updateStudentWellness(studentWellness) {
      this.dataContainer.portal.studentWellness = studentWellness;
      this.checkChanged();
    },
    updatePortal(portal) {
      this.dataContainer.portal = portal;
      this.checkChanged();
    },
    updateTheme(theme) {
      this.dataContainer.portal.theme.Vuetify.Light = theme;
      this.systemColors = theme;
      this.checkChanged();
    },
    updateGeneralSettings(portal) {
      // console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
      this.dataContainer.portal.languages = portal.languages;
      this.dataContainer.portal.planNumber = portal.planNumber;
      this.dataContainer.portal.hasBeneficiaries = portal.hasBeneficiaries;
      this.dataContainer.portal.mustAddBeneficiaries =
        portal.mustAddBeneficiaries;
      this.dataContainer.portal.restrictEmailOnRegistraton =
        portal.restrictEmailOnRegistraton;
      this.dataContainer.portal.planAdministratorName =
        portal.planAdministratorName;
      for (const lang of this.languages) {
        this.dataContainer.portal[
          `planAdministratorName${this.$helpers.toPascalCase(lang.language)}`
        ] =
          portal[
            `planAdministratorName${this.$helpers.toPascalCase(lang.language)}`
          ];
        this.dataContainer.portal[
          `planAdministrator${this.$helpers.toPascalCase(lang.language)}`
        ] =
          portal[
            `planAdministrator${this.$helpers.toPascalCase(lang.language)}`
          ];
        this.dataContainer.portal[
          `planAdministratorWebsite${this.$helpers.toPascalCase(lang.language)}`
        ] =
          portal[
            `planAdministratorWebsite${this.$helpers.toPascalCase(
              lang.language
            )}`
          ];
        this.dataContainer.portal[
          `logo${this.$helpers.toPascalCase(lang.language)}`
        ] = portal[`logo${this.$helpers.toPascalCase(lang.language)}`];
      }
      this.dataContainer.portal.planAdministrator = portal.planAdministrator;
      this.dataContainer.portal.planSponsorAddress = portal.planSponsorAddress;
      this.dataContainer.portal.planAdministratorWebsite =
        portal.planAdministratorWebsite;
      this.dataContainer.portal.isDemoMockPlan = portal.isDemoMockPlan;
      this.dataContainer.portal.hasDemoHSA = portal.hasDemoHSA;
      this.dataContainer.portal.isPensionsPortal = portal.isPensionsPortal;
      this.dataContainer.portal.restrictRegisterEmails =
        portal.restrictRegisterEmails;
      this.dataContainer.portal.hasProviderSearch = portal.hasProviderSearch;
      this.dataContainer.portal.hasDrugSearch = portal.hasDrugSearch;
      this.dataContainer.portal.enableClaims = portal.enableClaims;
      this.dataContainer.portal.enableClaimsMessage =
        portal.enableClaimsMessage;
      this.dataContainer.portal.memberHasSickPay = portal.memberHasSickPay;
      this.dataContainer.portal.logo = portal.logo;
      this.dataContainer.portal.favicon = portal.favicon;
      this.dataContainer.portal.canOptout = portal.canOptout;
      this.dataContainer.portal.shortNameForID = portal.shortNameForID;
      this.dataContainer.portal.allowedEmailDomains = portal.allowedEmailDomains;
      this.dataContainer.portal.planInformation = portal.planInformation;
      this.dataContainer.portal.contractInformation =
        portal.contractInformation;
      this.dataContainer.portal.hasPreferredProviders =
        portal.hasPreferredProviders;
      this.dataContainer.portal.canEditDependants = portal.canEditDependants;
      this.dataContainer.portal.certificateDigits = portal.certificateDigits;
      this.dataContainer.portal.allowedMonthsOfClaiming =
        portal.allowedMonthsOfClaiming;
      this.checkChanged();
    },
    updateContent(portal) {
      this.dataContainer.portal.showCertificateLabelAs =
        portal.showCertificateLabelAs;
      this.dataContainer.portal.showMemberGroupLabelAs =
        portal.showMemberGroupLabelAs;
      this.dataContainer.portal.memberValidateTooltip =
        portal.memberValidateTooltip;
      this.dataContainer.portal.claimsHistoryNote = portal.claimsHistoryNote;
      this.dataContainer.portal.benefitsBalanceNote =
        portal.benefitsBalanceNote;
      this.dataContainer.portal.HSAnote = portal.HSAnote;
      this.dataContainer.portal.dependantDefinition =
        portal.dependantDefinition;
      this.dataContainer.portal.drugExceptionNote = portal.drugExceptionNote;
      this.dataContainer.portal.benefitCardsNote = portal.benefitCardsNote;
      if (
        this.dataContainer.portal.benefitCardsNote !== null &&
        this.dataContainer.portal.benefitCardsNote !== undefined
      ) {
        for (const key of Object.keys(portal.benefitCardsNote)) {
          this.dataContainer.portal.benefitCardsNote[key] =
            portal.benefitCardsNote[key];
        }
      }
      this.dataContainer.portal.providerSearchNote = portal.providerSearchNote;
      this.dataContainer.portal.drugSearchNote = portal.drugSearchNote;

      this.checkChanged();
    },
    updateContact(portal) {
      this.dataContainer.portal.contactInfo = portal.contactInfo;
      this.dataContainer.portal.contactUsNote = portal.contactUsNote;
      this.dataContainer.portal.contactRequestType = portal.contactRequestType;
      this.dataContainer.portal.contactSubjectType = portal.contactSubjectType;

      this.checkChanged();
    },
    updateFooter(portal) {
      console.log("-------------------------------update footer");
      for (const lang of this.languages) {
        this.dataContainer.portal.footerItems[
          `leftText${lang.language.toUpperCase()}`
        ] = portal.footerItems[`leftText${lang.language.toUpperCase()}`];
        this.dataContainer.portal.footerItems[
          `leftLogo${this.$helpers.toPascalCase(lang.language)}`
        ] =
          portal.footerItems[
            `leftLogo${this.$helpers.toPascalCase(lang.language)}`
          ];
        this.dataContainer.portal.footerItems[
          `leftLogoLink${this.$helpers.toPascalCase(lang.language)}`
        ] =
          portal.footerItems[
            `leftLogoLink${this.$helpers.toPascalCase(lang.language)}`
          ];
      }
      this.dataContainer.portal.footerItems.leftLogo =
        portal.footerItems.leftLogo;
      this.dataContainer.portal.footerItems.leftLogoLink =
        portal.footerItems.leftLogoLink;

      this.checkChanged();
    },
    updateDemo(portal) {
      this.dataContainer.portal.demoPlansList = portal.demoPlansList;
      this.dataContainer.portal.demoBenefitCards = portal.demoBenefitCards;

      this.checkChanged();
    },
    updateAdvanced(portal) {
      this.dataContainer.portal.dashboardItemTypes = portal.dashboardItemTypes;
      this.dataContainer.portal.pensionInformationItems =
        portal.pensionInformationItems;
      this.dataContainer.portal.horizontalMenuItems =
        portal.horizontalMenuItems;
      this.dataContainer.portal.memberRegistrationComponent.Name =
        portal.memberRegistrationComponent.Name;
      this.dataContainer.portal.registrationCompletionComponent.Name =
        portal.registrationCompletionComponent.Name;

      this.checkChanged();
    },
    updateDownloadCentreCategories(categories) {
      this.dataContainer.portal.downloadCentreCategories = categories;
      let existing = [];
      let items = JSON.parse(
        JSON.stringify(this.dataContainer.portal.downloadCentreData)
      );
      for (let item of items) {
        existing = categories.filter((o) => o.CategoryEN === item.CategoryEN);
        if (existing.length > 0) {
          item.CategoryIcon = existing[0].CategoryIcon;
          item.CategoryIconColor = existing[0].CategoryIconColor;
          item.CategoryTabColor = existing[0].CategoryTabColor;
        } else {
          item.CategoryEN = null;
          item.CategoryFR = null;
          item.CategoryIcon = null;
          item.CategoryIconColor = null;
          item.CategoryTabColor = null;
        }
      }
      this.dataContainer.portal.downloadCentreData = items;

      this.checkChanged();
    },
    updateFaqGroups(groups) {
      this.dataContainer.portal.faqGroups = groups;
      let existing = [];
      let items = JSON.parse(JSON.stringify(this.dataContainer.portal.faq));
      for (let item of items) {
        existing = groups.filter((o) => o.GroupEN === item.GroupEN);
        if (existing.length > 0) {
          item.GroupIcon = existing[0].GroupIcon;
          item.GroupIconColor = existing[0].GroupIconColor;
          item.GroupTabColor = existing[0].GroupTabColor;
        } else {
          item.GroupEN = null;
          item.GroupFR = null;
          item.GroupIcon = null;
          item.GroupIconColor = null;
          item.GroupTabColor = null;
        }
      }
      this.dataContainer.portal.faq = items;

      this.checkChanged();
    },
    updateMleGroups(groups) {
      this.dataContainer.portal.mleGroups = groups;
      let existing = [];
      let items = JSON.parse(
        JSON.stringify(this.dataContainer.portal.lifeEventsCCWIPP.Members)
      );
      for (let item of items) {
        existing = groups.filter((o) => o.GroupEN === item.GroupEN);
        if (existing.length > 0) {
          item.GroupIcon = existing[0].GroupIcon;
          item.GroupIconColor = existing[0].GroupIconColor;
        } else {
          item.GroupEN = null;
          item.GroupFR = null;
          item.GroupIcon = null;
          item.GroupIconColor = null;
        }
      }
      this.dataContainer.portal.lifeEventsCCWIPP.Members = items;

      this.checkChanged();
    },
    updateMleCategories(categories) {
      this.dataContainer.portal.mleCategories = categories;
      let existing = [];
      let items = JSON.parse(
        JSON.stringify(this.dataContainer.portal.lifeEventsCCWIPP.Members)
      );
      for (let item of items) {
        existing = categories.filter((o) => o.CategoryEN === item.CategoryEN);
        if (existing.length > 0) {
          item.CategoryId = existing[0].CategoryId;
          item.CategoryImage = existing[0].CategoryImage;
          item.CategoryTextEN = existing[0].CategoryTextEN;
          item.CategoryTextFR = existing[0].CategoryTextFR;
        } else {
          item.CategoryId = null;
          item.CategoryEN = null;
          item.CategoryFR = null;
          item.CategoryImage = null;
          item.CategoryTextEN = null;
          item.CategoryTextFR = null;
        }
      }
      this.dataContainer.portal.lifeEventsCCWIPP.Members = items;

      this.checkChanged();
    },
    updateLifeEvents(items) {
      this.dataContainer.portal.lifeEventsCCWIPP.Members = items;
      this.checkChanged();
    },
    updatePpCategories(categories) {
      // console.log(
      //   "*************************************************^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^***",
      //   categories,
      //   this.dataContainer.portal.ppCategories,
      //   this.dataContainer.portal.providers
      // );

      let items = JSON.parse(JSON.stringify(categories));
      for (let item of items) {
        item.Providers = this.dataContainer.portal.providers
          .filter((o) => o.CategoryId === item.CategoryId)
          .map((o) => {
            o.Info = [];
            o.Info.push({});
            o.Info.push({});
            o.Info.push({});
            for (const lang of this.languages) {
              o.Info[0][`Title${lang.language.toUpperCase()}`] =
                o[`Title${lang.language.toUpperCase()}`];
              o.Info[0][`Image${lang.language.toUpperCase()}`] =
                o[`Image${lang.language.toUpperCase()}`];
              o.Info[0][`Detail${lang.language.toUpperCase()}`] =
                o[`Detail${lang.language.toUpperCase()}`];

              o.Info[1][`Title${lang.language.toUpperCase()}`] =
                lang.language.toUpperCase() === "EN"
                  ? "Description"
                  : `Description`;
              // : `Description ${lang.language.toUpperCase()}`;
              o.Info[1][`Image${lang.language.toUpperCase()}`] = "";
              o.Info[1][`Detail${lang.language.toUpperCase()}`] =
                o[`DescriptionDetail${lang.language.toUpperCase()}`];

              o.Info[2][`Title${lang.language.toUpperCase()}`] =
                lang.language.toUpperCase() === "EN"
                  ? "Contact Information"
                  : "Información del contacto";
              // : `Contact Information ${lang.language.toUpperCase()}`;
              o.Info[2][`Image${lang.language.toUpperCase()}`] = "";
              o.Info[2][`Detail${lang.language.toUpperCase()}`] =
                o[`ContactInformationDetail${lang.language.toUpperCase()}`];
            }
            // console.log(JSON.stringify(o));
            return o;
          });
      }
      this.dataContainer.portal.ppCategories = items;
      this.dataContainer.portal.preferredProviders = items;

      this.checkChanged();
    },
    updateProvs(items) {
      // console.log(
      //   "----------------------------------------------------",
      //   items,
      //   this.dataContainer.portal.ppCategories,
      //   this.dataContainer.portal.providers
      // );
      this.dataContainer.portal.providers = items;
      for (let item of this.dataContainer.portal.preferredProviders) {
        item.Providers = this.dataContainer.portal.providers
          .filter((o) => o.CategoryId === item.CategoryId)
          .map((o) => {
            o.Info = [];
            o.Info.push({});
            o.Info.push({});
            o.Info.push({});
            for (const lang of this.languages) {
              // console.log(
              //   "$$$$$$$$$$$$$$$$$$$$$$$$$$",
              //   lang,
              //   `Title${lang.language.toUpperCase()}`
              // );

              o.Info[0][`Title${lang.language.toUpperCase()}`] =
                o[`Title${lang.language.toUpperCase()}`];
              o.Info[0][`Image${lang.language.toUpperCase()}`] =
                o[`Image${lang.language.toUpperCase()}`];
              o.Info[0][`Detail${lang.language.toUpperCase()}`] =
                o[`Detail${lang.language.toUpperCase()}`];

              o.Info[1][`Title${lang.language.toUpperCase()}`] =
                lang.language.toUpperCase() === "EN"
                  ? "Description"
                  : `Description`;
              // : `Description ${lang.language.toUpperCase()}`;
              // o.Info[1][`Image${lang.language.toUpperCase()}`] = "";
              o.Info[1][`Detail${lang.language.toUpperCase()}`] =
                o[`DescriptionDetail${lang.language.toUpperCase()}`];

              o.Info[2][`Title${lang.language.toUpperCase()}`] =
                lang.language.toUpperCase() === "EN"
                  ? "Contact Information"
                  : "Información del contacto";
              // : `Contact Information ${lang.language.toUpperCase()}`;
              // o.Info[2][`Image${lang.language.toUpperCase()}`] = "";
              o.Info[2][`Detail${lang.language.toUpperCase()}`] =
                o[`ContactInformationDetail${lang.language.toUpperCase()}`];
            }
            // console.log(JSON.stringify(o));
            return o;
          });
      }
      this.checkChanged();
    },
    checkChanged() {
      this.isChanged = !this.sameObject(
        this.originalData,
        this.removeIdentifiers(
          JSON.parse(JSON.stringify(this.dataContainer.portal))
        )
      );
      console.log("isChanged, isValid: ",this.isChanged, this.isValid, this.valid);
    },
    sameObject(original, clone) {
      console.log(JSON.stringify(original));
      console.log(JSON.stringify(clone));
      // return false;
      if (original === null || original === undefined) {
        console.log("is same 1");
        return clone === null || clone === undefined;
      }
      if (clone === null || clone === undefined) {
        console.log("is same 2");
        return false;
      }

      const originalKeys = Object.keys(original);
      const cloneKeys = Object.keys(clone);
      console.log(
        "is same 2.1",
        JSON.stringify(originalKeys),
        JSON.stringify(cloneKeys)
      );
      if (originalKeys.length !== cloneKeys.length) {
        console.log("is same 3", originalKeys, cloneKeys);
        return false;
      }
      console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
      let isSame = true;
      for (let key of originalKeys) {
        console.log(key, original[key], typeof original[key]);
        if (original[key] === null || original[key] === undefined) {
          isSame = clone[key] === null || clone[key] === undefined;
        } else if (typeof original[key] === "object") {
          if (Array.isArray(original[key])) {
            console.log("is array");
            if (!Array.isArray(clone[key])) {
              console.log("is same 4", key, JSON.stringify(original[key]));
              if (original[key].length !== 0 || clone[key] !== undefined) {
                return false;
              }
            }
            console.log("*********************************", key);
            // if (original[key] === undefined && key ==='Members') {
            //   console.log("%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%", key)
            //   original.Members = [];
            // }
            // if (clone[key] === undefined && key ==='Members') {
            //   console.log("wtf", key)
            //   clone.Members = [];
            // }
            if (original[key].length !== clone[key].length) {
              console.log(
                "is same 7",
                key,
                JSON.stringify(original[key]),
                JSON.stringify(clone[key])
              );
              return false;
            }
            for (let i = 0; i < original[key].length; i++) {
              console.log(original[key][i], clone[key][i]);
              isSame = this.sameObject(original[key][i], clone[key][i]);
              if (!isSame) {
                console.log("is same 5");
                return false;
              }
            }
          } else {
            isSame = this.sameObject(original[key], clone[key]);
          }
        } else {
          // if (
          //   key === "DateOfService" &&
          //   clone[key].length > original[key].length
          // ) {
          //   const a = clone[key].slice(0, clone[key].length - 5) + "Z";
          //   clone[key] = a;
          // }
          isSame = original[key] === clone[key];
        }
        if (!isSame) {
          console.log(
            "is same 6",
            key,
            JSON.stringify(original[key]),
            JSON.stringify(clone[key]),
            this.isValid
          );
          return false;
        }
      }
      return isSame;
    },
  },
};
</script>
<style scoped>
.v-card-icon {
  border-radius: 3px;
  padding: 20px;
  top: -14px;
  max-width: 64px;
  left: 15px;
  box-shadow: 0 12px 20px -10px rgba(76, 175, 80, 0.28),
    0 4px 20px 0 rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(76, 175, 80, 0.2);
  position: absolute;
}
</style>
